<div class="mx-auto w-full">
    <div
        class="bg-white shadow-xl mx-auto rounded-xl p-8 max-w-4xl w-full text-center animate-fade-in"
    >
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">
            {{ 'ACCOUNT_CHANGE' | translate }}
        </h2>
        <p class="text-gray-600 text-lg mb-2">
            {{ 'DISCONNECT_COUNTDOWN' | translate : { countdown: countdown } }}
        </p>
        <p class="text-gray-500 text-sm">
            {{ 'REDIRECT_MESSAGE' | translate }}
        </p>

        <div class="w-full h-2 bg-gray-200 rounded-full mt-6 overflow-hidden">
            <div
                class="h-full bg-blue-500 transition-all duration-1000"
                [style.width.%]="((3 - countdown) * 100) / 3"
            ></div>
        </div>
    </div>
</div>
